export { FikoThreeJsComponent } from './fiko-three-js.component';

// ==================== MINI 3D VIEWER (Dialog için) ====================
export * from './fiko-mini-3d';

// Export analiz system
export * from './IFikoThreeJS/fiko-analiz';

// ==================== MEVCUT PERFORMANCE SYSTEMS ====================
// Mevcut performans modülleri

// Mevcut Performance Components
export { FikoDynamicResolutionScaler } from './IFikoThreeJS/fiko-performance/FikoDynamicResolutionScaler';
export { FikoMeshCompressor } from './IFikoThreeJS/fiko-performance/FikoMeshCompressor';
export { FikoInstancedOptimizer } from './IFikoThreeJS/fiko-performance/FikoInstancedOptimizer';
export { FikoVirtualTextures } from './IFikoThreeJS/fiko-performance/FikoVirtualTextures';
export { FikoPerformanceManager } from './IFikoThreeJS/fiko-performance/FikoPerformanceManager';

// WebGPU
export { FikoWebGPU } from './IFikoThreeJS/fiko-performance/FikoWebGPU';

// Smart Point Systems
export { FikoSmartPoint } from './IFikoThreeJS/FikoSmartPoint';
export { FikoSmartPoint3D } from './IFikoThreeJS/FikoSmartPoint3D';

// ==================== DFM ANALYSIS ====================
// Design for Manufacturing Analysis Panel
export * from './IFikoThreeJS/fiko-dfm';

